import type { File } from '@/types/api'

function getExtension(file: File) {
  return file.fileName?.split('.').pop() ?? ''
}

function showThumbnail(file: File) {
  const fileExtension = getExtension(file)
  return file.imageRatio !== null || fileExtension === 'pdf'
}

function getFormattedSize(file: File) {
  let remainingSize = Number(file.fileSize ?? '0')
  let result = ''
  let level = 1
  const maxLevel = 1
  const units = {
    TB: 1099511627776,
    GB: 1073741824,
    MB: 1048576,
    kB: 1024,
    B: 1,
  }
  for (const [unit, inBytes] of Object.entries(units)) {
    if (remainingSize >= inBytes) {
      const unitSize = remainingSize / inBytes
      const intUnitSize = parseInt(unitSize.toString())
      result +=
        (level >= maxLevel
          ? +(Math.round(+(unitSize + 'e+1')) + 'e-1')
          : intUnitSize) +
        unit +
        ' '
      remainingSize -= intUnitSize * inBytes
      if (level++ >= maxLevel) {
        break
      }
    }
  }
  return result.trim()
}

export const fileUtils = {
  getExtension,
  showThumbnail,
  getFormattedSize,
}
